import React from "react";
import { Bath, DoorOpen, Mountain, Tent, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";

const ServicesSection = () => {
  const handleLearnMore = (serviceName) => {
    if (serviceName === "Rifacimenti") {
      // Scroll alla sezione bagni dettagliata
      const element = document.getElementById('rifacimenti-dettagli');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else if (serviceName === "Serramenti") {
      // Scroll alla sezione serramenti dettagliata
      const element = document.getElementById('serramenti-dettagli');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else if (serviceName === "Vetrate Panoramiche") {
      // Scroll alla sezione vetrate dettagliata - SISTEMATO!
      const element = document.getElementById('vetrate-dettagli');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else if (serviceName === "Ristrutturazioni di Prestigio") {
      // Scroll alla sezione ristrutturazioni prestigio
      const element = document.getElementById('prestigio-dettagli');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      alert(`Vuoi sapere di più su: ${serviceName}?\n\nContattaci per maggiori informazioni!`);
    }
  };

  const services = [
    {
      icon: Bath,
      title: "Rifacimenti",
      subtitle: "Bagni-Docce",
      description: "Trasformiamo il tuo bagno in uno spazio moderno e funzionale, con materiali di qualità e design su misura.",
      image: "/images/hero1.jpeg",
      features: ["Progettazione 3D", "Materiali premium", "Installazione professionale"]
    },
    {
      icon: DoorOpen,
      title: "Serramenti",
      subtitle: "Infissi-porte-blindati",
      description: "Infissi e serramenti di alta qualità per migliorare l'efficienza energetica e la sicurezza della tua casa.",
      image: "/images/hero7.png",
      features: ["Isolamento termico", "Sicurezza avanzata", "Design personalizzato"]
    },
    {
      icon: Mountain,
      title: "Vetrate Panoramiche",
      subtitle: "Privati-Aziende",
      description: "Soluzioni innovative per ampliare gli spazi e creare continuità tra interno ed esterno.",
      image: "/images/hero8.png",
      features: ["Vetri temperati", "Sistemi scorrevoli", "Massima luminosità"]
    },
    {
      icon: Tent,
      title: "Ristrutturazioni di Prestigio",
      subtitle: "Edifici Storici-Luxury",
      description: "Ristrutturazioni complete di edifici storici e di prestigio, con particolare attenzione ai dettagli architettonici e materiali di alta qualità.",
      image: "/images/about4.jpg",
      features: ["Restauro architettonico", "Materiali di lusso", "Design personalizzato"]
    }
  ];

  return (
    <section id="services" className="py-20 lg:py-32 bg-white">
      <div className="container mx-auto px-4 lg:px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            I nostri <span className="text-blue-600">servizi</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Offriamo soluzioni complete per la tua casa, dalla progettazione alla realizzazione,
            con materiali di qualità e tecnologie all'avanguardia.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {services.map((service, index) => (
            <Card
              key={index}
              className="group hover:shadow-2xl transition-all duration-500 border-0 shadow-lg overflow-hidden"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <div className="bg-white/90 backdrop-blur-sm p-3 rounded-full">
                    <service.icon className="h-6 w-6 text-blue-600" />
                  </div>
                </div>
              </div>
              
              <CardContent className="p-8">
                <div className="mb-4">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{service.title}</h3>
                  <p className="text-lg text-blue-600 font-medium">{service.subtitle}</p>
                </div>
                
                <p className="text-gray-700 mb-6 leading-relaxed">{service.description}</p>
                
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-600">
                      <ArrowRight className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <Button
                  variant="outline"
                  className="w-full group-hover:bg-blue-600 group-hover:text-white group-hover:border-blue-600 transition-all duration-300"
                  onClick={() => handleLearnMore(service.title)}
                >
                  Scopri di più
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;